
import { lengthFacts } from './facts/length-facts';
import { weightFacts } from './facts/weight-facts';
import { timeFacts } from './facts/time-facts';
import { volumeFacts } from './facts/volume-facts';
import { areaFacts } from './facts/area-facts';
import { speedFacts } from './facts/speed-facts';
import { temperatureFacts } from './facts/temperature-facts';

export interface UnitHistory {
  name: string;
  shortDescription: string;
  history: string;
  origin: string;
  modernUsage: string;
  funFacts: string[];
  related?: string[];
  images: {
    url: string;
    caption: string;
    altText: string;
  }[];
}

export type UnitHistories = {
  [key: string]: UnitHistory;
};

// Export all fact collections
export const unitSpecificFacts = {
  ...lengthFacts,
  ...weightFacts,
  ...timeFacts,
  ...volumeFacts,
  ...areaFacts,
  ...speedFacts,
  ...temperatureFacts
};

// Also export individual collections
export { lengthFacts, weightFacts, timeFacts, volumeFacts, areaFacts, speedFacts, temperatureFacts };
